import React from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import { Dialog as SDialog } from "@tencent/spaui"

const PADDING = 5
const MIN_WIDTH = 100
const MIN_HEIGHT = 40

class Dialog extends React.Component {
  state = {}

  inner = React.createRef()

  componentDidMount() {
    const dialogEl = ReactDOM.findDOMNode(this)
    if (dialogEl) {
      this.contentEl = dialogEl.querySelector(".modal-content")
      window.addEventListener("mousemove", this.handleMouseMove, false)
      if (this.contentEl) {
        // move
        const header = this.contentEl.querySelector(".modal-header")
        header && header.addEventListener("mousedown", this.handleMouseDownInHeader, false)
        // resize
        this.bodyEl = this.contentEl.querySelector(".modal-body")
        this.contentEl.addEventListener("mousedown", this.handleMouseDown, false)
      }
    }
  }

  componentWillUnmount() {
    if (this.contentEl) {
      const header = this.contentEl.querySelector(".modal-header")
      header && header.removeEventListener("mousedown", this.handleMouseDownInHeader, false)
      this.contentEl.removeEventListener("mousedown", this.handleMouseDown, false)
      window.removeEventListener("mousemove", this.handleMouseMove, false)
      window.removeEventListener("mouseup", this.handleMouseUp, false)
    }
    if (this.originalBodyClassName) {
      document.body.className = this.originalBodyClassName
    }
  }

  handleMouseDownInHeader = (e) => {
    // 如果没有标注特定模式，则默认为移动对话框
    if (!this.mode) {
      this.mode = "move"
      this.originalBodyClassName = document.body.className
      document.body.className = this.originalBodyClassName + " dragging"
    }
    this.markStart(e)
  }

  handleMouseDown = (e) => {
    this.mode && this.markStart(e)
  }

  handleMouseMove = (e) => {
    // 如果正处于某种处理的过程中，则继续
    if (this.mode && this.enabled) {
      this.progress(e)
    }
    // 否则检测后续的操作模式（仅针对顶层对话框）
    else if (this.inner.current && this.inner.current.isOnTop()) {
      this.detectMode(e)
    }
  }

  handleMouseUp = () => {
    if (!this.mode || !this.enabled) {
      return
    }
    this.markFinish()
  }

  /**
   * 检测对话框的模式
   * @param e
   */
  detectMode(e) {
    const offsetLeft = this.contentEl.offsetLeft + (this.contentEl.offsetParent ? this.contentEl.offsetParent.offsetLeft : 0)
    const offsetTop = this.contentEl.offsetTop + (this.contentEl.offsetParent ? this.contentEl.offsetParent.offsetTop : 0)
    const offsetRight = offsetLeft + this.contentEl.clientWidth
    const offsetBottom = offsetTop + this.contentEl.clientHeight
    const left = e.clientX > offsetLeft && e.clientX - offsetLeft <= PADDING
    const top = e.clientY > offsetTop && e.clientY - offsetTop <= PADDING
    const right = left ? false : e.clientX < offsetRight && offsetRight - e.clientX <= PADDING
    const bottom = top ? false : e.clientY < offsetBottom && offsetBottom - e.clientY <= PADDING
    if (left || top || right || bottom) {
      const mode = `resize_${left ? "left" : ""}${right ? "right" : ""}${top ? "top" : ""}${bottom ? "bottom" : ""}`
      if (this.mode !== mode) {
        this.mode = mode
        if (!this.originalBodyClassName) {
          this.originalBodyClassName = document.body.className
        }
        document.body.className = this.originalBodyClassName + " " + mode
      }
    } else if (this.mode) {
      this.mode = undefined
      document.body.className = this.originalBodyClassName
    }
  }

  /**
   * 记录开始信息
   * @param e
   */
  markStart(e) {
    this.enabled = true
    this.start = this.finish = {
      x: e.screenX,
      y: e.screenY,
    }
    this.base = {
      x: parseInt(this.contentEl.style.marginTop || 0),
      y: parseInt(this.contentEl.style.marginLeft || 0),
      w: this.contentEl.clientWidth,
      h: this.bodyEl.clientHeight,
    }
    window.addEventListener("mouseup", this.handleMouseUp, false)
  }

  /**
   * 处理变换
   * @param e
   */
  progress(e) {
    this.finish = {
      x: e.screenX,
      y: e.screenY,
    }
    const delta = {
      x: this.finish.x - this.start.x,
      y: this.finish.y - this.start.y,
    }
    if (this.mode === "move") {
      this.contentEl.style.marginTop = this.base.x + delta.y + "px"
      this.contentEl.style.marginLeft = this.base.y + delta.x + "px"
    } else {
      if (this.mode.indexOf("left") >= 0) {
        if (this.base.w - delta.x > MIN_WIDTH) {
          this.contentEl.style.marginLeft = this.base.y + delta.x + "px"
          this.contentEl.style.width = this.base.w - delta.x + "px"
        }
      } else if (this.mode.indexOf("right") >= 0) {
        if (this.base.w + delta.x > MIN_WIDTH) {
          this.contentEl.style.width = this.base.w + delta.x + "px"
        }
      }
      if (this.mode.indexOf("top") >= 0) {
        if (this.base.h - delta.y > MIN_HEIGHT) {
          this.contentEl.style.marginTop = this.base.x + delta.y + "px"
          this.bodyEl.style.height = this.base.h - delta.y + "px"
        }
      } else if (this.mode.indexOf("bottom") >= 0) {
        if (this.base.h + delta.y > MIN_HEIGHT) {
          this.bodyEl.style.height = this.base.h + delta.y + "px"
        }
      }
    }
  }

  /**
   * 标注完成结果（即清理）
   */
  markFinish() {
    if (this.mode === "move") {
      this.mode = undefined
    }
    this.enabled = false
    this.start = this.finish = this.base = undefined
    document.body.className = this.originalBodyClassName
    window.removeEventListener("mouseup", this.handleMouseUp, false)
  }

  render() {
    const props = this.props
    return <SDialog ref={this.inner} type={"normal"} escHide={true} {...props} />
  }
}

export default Dialog
